import { useState, useEffect } from "react";
import "./App.css";
import Lenis from "@studio-freight/lenis";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Banner from "./components/Banner";
import Review from "./components/Review";
import Offer from "./components/Offer";
import Services from "./components/Services";
import Price from "./components/Price";
import Links from "./components/Links";
import Form from "./components/Form";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

function App() {
  const [animateNavbar, setAnimateNavbar] = useState(false);
  const [animateHero, setAnimateHero] = useState(false);

  useEffect(() => {
    // Directly run smooth scroll without waiting for loader
    const lenis = new Lenis();

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };

    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  // Trigger navbar animation immediately
  useEffect(() => {
    setAnimateNavbar(true);
  }, []);

  const handleNavbarComplete = () => {
    setAnimateHero(true); // Trigger Hero animation once Navbar completes
  };

  return (
    <div className="App">
      <Navbar animate={animateNavbar} onComplete={handleNavbarComplete} />
      <Hero animate={animateHero} />
      <About />
      <Banner />
      <Offer />
      <Review />
      <Services />
      <Price />
      <Links />
      <Form />
      <Faq />
      <Footer />
    </div>
  );
}

export default App;
